<template>
    <path :style="{ fill: color }" d="M31.9,32.2C31.6,30,29.6,22,31.4,19.1c1.8-2.9,5-5.3,7.1-7.2c2.7-2.4,4.8-2.7,7.2-2.3
	c0.2,0,0.3,0,0.5,0.1c0.4-0.6,0.8-1.1,1.5-1.6c1.6-1.2,1.6-0.9,3.7-2.4s2.6-3.1,4.9-3.5c0.8-0.1,2,0.3,3.1,0.8
	c2.3-1.4,3.6-2.2,3.6-2.2s3.9,1.3,6.3,4.8c2.4,3.5,2,8.3,2,8.3c1,1.8,2.4,1,5.1,4.3c2.7,3.2-0.1,13-0.4,16.7
	c-0.1,1.1,0.2,2.5,0.1,3.5c-0.1,2-0.5,3.2-0.5,3.4c-0.8,0.6-1.5,4.9-1.8,4.9c-0.3-0.1-0.4-3.2-0.5-5c-0.1-1.6-1.2-3.1-1.4-6
	c-0.1-2.9,0.6-5-1.5-8c-2.1-2.9-7.2,0.6-15.9,0.6c-8.6,0-12.2-3.1-15.1-2c-2.9,1.1-2.3,6.6-2.6,8.9c-0.3,2.3-1,3.8-1.3,6
	c-0.4,2.8,0,6-0.4,6.1c-0.4,0.1-0.8-4.9-2.2-5.5c0,0-0.4-1-0.4-2.9c0-0.9,0.1-2.1,0-3.3C32.3,34.1,32,32.7,31.9,32.2z"/>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair4',
        mixins: [Hair],
    }
</script>

